import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { DDS_DURATION_OPTIONS } from '@/types'
import { formatDurationMinutes } from '@/utils/dds-attendance'

interface DdsDurationPickerProps {
	value: number
	onChange: (minutes: number) => void
	disabled?: boolean
	className?: string
}

export const DdsDurationPicker = ({
	value,
	onChange,
	disabled,
	className,
}: DdsDurationPickerProps) => {
	const { t } = useTranslation()

	return (
		<fieldset
			className={cn('flex flex-wrap gap-2', className)}
			disabled={disabled}
		>
			<legend className="sr-only">{t('form.dds.durationLabel')}</legend>
			{DDS_DURATION_OPTIONS.map((minutes) => (
				<Button
					aria-pressed={value === minutes}
					key={minutes}
					onClick={() => onChange(minutes)}
					size="sm"
					type="button"
					variant={value === minutes ? 'default' : 'outline'}
				>
					{formatDurationMinutes(minutes)}
				</Button>
			))}
		</fieldset>
	)
}
